import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'FilesIcon',
  functional: true,
  render: function render(h, ctx) {
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 492.924 492.924",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      },
      "class": "feather"
    }, ctx.data]), [h("path", {
      attrs: {
        d: "M405.825,0H188.709c-19.016,0.008-34.5,15.49-34.518,34.521v16.297h-16.303c-19.017,0.01-34.5,15.498-34.514,34.521v16.309\n" +
            "\tH87.082c-19.029,0.006-34.494,15.482-34.514,34.522l0.02,322.238c-0.02,19.043,15.465,34.525,34.494,34.516h152.538\n" +
            "\tc10.65,0,20.871-4.203,28.438-11.696l39.516-39.124h47.415c19.063,0.01,34.546-15.473,34.532-34.512v-16.314h16.303\n" +
            "\tc19.048,0.008,34.53-15.477,34.512-34.508l0.019-322.248C440.336,15.482,424.873,0.008,405.825,0z M311.457,391.963h-39.962\n" +
            "\tc-4.777,0-9.305,0.967-13.438,2.719c-12.382,5.248-21.079,17.529-21.093,31.811v0.01v0.022l0.014,39.137H87.082\n" +
            "\tc-3.98,0-7.243-3.25-7.256-7.252V136.17c0-4,3.275-7.268,7.256-7.268l217.119,0.01c3.998,0,7.255,3.258,7.255,7.242V391.963z\n" +
            "\t M362.264,407.592c-0.02,3.99-3.276,7.248-7.274,7.248h-19.497c1.148-1.226,3.24-3.777,3.24-9.225c0-67.361,0-269.445,0-269.445\n" +
            "\tc-0.018-19.033-15.5-34.516-34.549-34.522H130.647V85.334c0-3.984,3.244-7.242,7.222-7.242l217.121-0.01\n" +
            "\tc3.998,0,7.274,3.268,7.274,7.258V407.592z M413.084,356.77c-0.02,3.992-3.275,7.25-7.26,7.25h-16.303l0.014-278.68\n" +
            "\tc-0.014-19.029-15.482-34.512-34.546-34.521H181.467V34.514c0-3.992,3.258-7.242,7.223-7.242l217.135-0.008\n" +
            "\tc3.984,0,7.26,3.258,7.26,7.258V356.77z"
      }
    })]);
  }
};